/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */

export const strings = {
  failUploadFile: 'File upload fail.',
  cancelUploadFile: 'File cancel.',
  buttonUploadFile: 'Upload Files',
  maximumFilesTitle: 'Maximum files',
  maximumFiles:
    'Sorry, the maximum number of files you can upload at once is {MaxNumber}. Do you want to upload the first {MaxNumber} files or reselect?',
  maximumFileSizeTitle: 'Maximum files size',
  maximumFileSize: 'Sorry, the maximum file size to upload is {FileSize}. The file "{FileName}" has ',
  fileTypeTitle: 'File type',
  fileType: 'Sorry, the format of following file "{FileName}" cannot be uploaded.',
  checkAgain: "Don't show again",
  checkApplyAll: 'Apply to all',
  buttonOk: 'OK',
  buttonCancel: 'Cancel',
  buttonUpload: 'Upload',
  buttonKeep: 'Keep',
  buttonReplace: 'Replace',
  buttonReselect: 'Reselect',
  fileReplaceTitle: 'Replace file',
  fileReplace: 'Do you want to replace the file "{FileName}" or keep file with new name?'
};
